// extracted by mini-css-extract-plugin
module.exports = {"EditAvatar":"EditAvatar_EditAvatar__1UdRC","EditAvatar__avatar":"EditAvatar_EditAvatar__avatar__ancaC","EditAvatar__upload":"EditAvatar_EditAvatar__upload__3uF7u"};